// These are prefixes of coupon codes that won't work with experimental pricing that we'll override error message to

import { Cart } from '../types/carts';
import { applyCouponToCart, isValidCodeResult } from './promoCode';

// indicate an adjusted code to try
export const PREPAID_COUPON_PREFIXES_TO_REPLACE = [
  'bark-',
  'app-stunt6-',
  'goody1-',
  'goody6-',
  'forma1-',
  'forma6-',
  'fringe1-',
  'fringe6-',
  'lt-',
  'thrive1-',
  'thrive2-',
  'thrive6-',
  // For S3+ switchover
  '221b-',
  '4luvncare-',
  'aagn-',
  'abcr-',
  'acom-',
  'activedog-',
  'adh-',
  'af-',
  'afar-',
  'ah-',
  'ahdr-',
  'ahs-',
  'alma-',
  'apa-',
  'app-acak9-',
  'app-adob-',
  'app-aplkn-',
  'app-bcgr-',
  'app-bfas-',
  'app-bfh-',
  'app-bfla-',
  'app-bfnwa-',
  'app-bfnyc-',
  'app-bfu-',
  'app-bibc-',
  'app-bnr-',
  'app-cdd-',
  'app-cojg-',
  'app-dok-',
  'app-efl-',
  'app-gtg-',
  'app-hhgold-',
  'app-kand-',
  'app-lhbgalgo-',
  'app-lp-',
  'app-lrf-',
  'app-luckydog-',
  'app-mdm-',
  'app-mg-',
  'app-moxxi-',
  'app-msgs-',
  'app-mudpaw-',
  'app-phgd-',
  'app-pip-',
  'app-plgd-',
  'app-poes-',
  'app-pondgold-',
  'app-royalg-',
  'app-rplc-',
  'app-rpr-',
  'app-saltypaws-',
  'app-schrm-',
  'app-smd-',
  'app-spp-',
  'app-srp-',
  'app-strlte-',
  'app-swdd-',
  'app-txd-',
  'app-txpuppy-',
  'app-v3gd-',
  'app-wmg-',
  'appaws-',
  'arlgp-',
  'asf-',
  'awhfd-',
  'b2tb-',
  'bar-k-',
  'barkbar-',
  'barkbus-',
  'barkhouse-',
  'barkngo-',
  'barkology-',
  'barkpark-',
  'barksbrews-',
  'barkside-',
  'barrkli-',
  'barxparx-',
  'baypaws-',
  'bbcr-',
  'bcn-',
  'bf-',
  'bfas-',
  'bfh-',
  'bfla-',
  'bfnwa-',
  'bfnyc-',
  'bfu-',
  'bhs-',
  'bibc-',
  'blankspaces-',
  'bluemoon-',
  'bodymindla-',
  'bond-',
  'boozymutt-',
  'boris-',
  'bowie-',
  'bpr-',
  'bpsd-',
  'brewpark-',
  'brokenleash-',
  'brrs-',
  'bryancoga-',
  'buddha-',
  'bv-',
  'bvc-emp-',
  'bw-',
  'bwh-',
  'caas-',
  'cadc-',
  'cbacc-',
  'chicon-',
  'ckphoto-',
  'cleo-',
  'cobrew-',
  'cpr-',
  'crateescape-',
  'crc-',
  'cshr-',
  'daisy-',
  'dapperdog-',
  'dcla-',
  'dd-',
  'ddsc-',
  'dgpr-',
  'dhd-',
  'diamonddog-',
  'dogbarstpete-',
  'dogdrop-',
  'doggos-',
  'doghood-',
  'doghouse-',
  'dogpenn-',
  'dogppl-',
  'dogsquad-',
  'dogwood-',
  'donc-',
  'doubledog-',
  'dp-',
  'dutch-',
  'emancipet-',
  'eola-',
  'ergolden-',
  'fable-',
  'fas-',
  'fcw-',
  'fetch-',
  'fetchpet-',
  'ffcbd-',
  'fidoruns-',
  'figo-',
  'fitpup-',
  'floof-',
  'fluffnbuff-',
  'fluffology-',
  'forum-',
  'frankie-',
  'freedt-',
  'freshpatch-',
  'fwt-',
  'gcs-',
  'gdrne-',
  'gfnj-',
  'gizmos-',
  'godog-',
  'gradysquare-',
  'growlerz-',
  'guard-',
  'hars-',
  'hearts-',
  'hh-',
  'hhdpr-',
  'highspeed-',
  'hlar-',
  'hlf-',
  'hotdawgq2-',
  'hpgdr-',
  'hsou-',
  'hsp-',
  'hsus25-',
  'ht-',
  'hudson-',
  'impact-',
  'ipa-',
  'irocker-',
  'jhra-',
  'jl-',
  'jogdatdog-',
  'jsac-',
  'k9r-',
  'k9ss-',
  'kahd-',
  'ken-',
  'khs-',
  'ks-',
  'laar-',
  'ladog-',
  'laeknir-',
  'lamar-',
  'lbf-',
  'lcar-',
  'lcrgala-',
  'ldrct-',
  'lf-',
  'lovepetcare-',
  'lovepup-',
  'lp-',
  'lpfdogmom-',
  'lphs-',
  'lppnc-',
  'lpr-',
  'lrrof-',
  'luckydog-',
  'lucys-',
  'm22-',
  'madmov-',
  'mandm-',
  'marpawws-',
  'mcas-',
  'mdmg-',
  'mercyfull-',
  'mf-',
  'midtown-',
  'moxxi-',
  'mp-',
  'msir-',
  'muddydog-',
  'mudpaw-',
  'mutts-',
  'mutts-ep-',
  'nativepet-',
  'neighbors-',
  'nest-',
  'newbegin-',
  'nisha-',
  'nishavip-',
  'ny25-',
  'nyc-',
  'oa-',
  'ochs-',
  'odb-',
  'ols-',
  'onduty-',
  'p4p-',
  'paca-',
  'pandp-',
  'park9-',
  'pasadenapaws-',
  'pato-',
  'paw-',
  'paws-',
  'paws48-',
  'pawsup-',
  'pawtime-',
  'paz-',
  'pc-',
  'pcr-',
  'pcrt-',
  'pcrust-',
  'petrushinn-',
  'pgj-',
  'ph-',
  'phillyacct-',
  'pip-',
  'plky-',
  'pnb-',
  'pnetwork-',
  'pnr-',
  'pohr-',
  'polkadog-',
  'poso-',
  'ppr-',
  'pralines-',
  'prr-',
  'pumpkin-',
  'pupclub-',
  'puppr-',
  'puppymanor-',
  'pupspub-',
  'pwob-',
  'rar-',
  'rascaldyroo-',
  'rb-',
  'rcc-',
  'rcr-',
  'renpaw-',
  'rescuemega-',
  'rnp-',
  'rome-',
  'rrf-',
  'ruffruffrun-',
  'runbud-',
  'samsonss-',
  'sandf-',
  'sandypaws-',
  'sar-',
  'saturday-',
  'scbh-',
  'scrr-',
  'sczoom-',
  'sdemp-',
  'shelterluv25-',
  'skiptown-',
  'skyhoundz-',
  'smd-',
  'sniffnsnack-',
  'souldog-',
  'spas-',
  'sploot-',
  'spokanimal-',
  'spot-',
  'spotsandstripes-',
  'ss-',
  'ssq2-',
  'ssully-',
  'subaru-a-',
  'sutton-',
  'svar-',
  'swesr-',
  'table-',
  'taf-',
  'tapsandtails-',
  'thrive-1-',
  'thrive-6-',
  'tinypaws-',
  'tldom-',
  'tmt-',
  'topanga-',
  'totaldog-',
  'tpgh-',
  'traprs-',
  'tribeagle-',
  'tsp-',
  'tty-',
  'twoshep-',
  'unleashed-',
  'upshot-',
  'urban-',
  'ute-',
  'utrq2-',
  'veg-den-emp-',
  'vernon-',
  'vip-',
  'vw-',
  'wagbar-',
  'walkatx-',
  'wandw-',
  'warf-',
  'wateringbowl-',
  'wavpaw-',
  'waw-',
  'wawtn-',
  'wdc-',
  'weenie-',
  'wh-',
  'wild-',
  'wildnfi-',
  'woofboard-',
  'wras-',
  'wsw-',
  'ww-',
  'yardbar-',
  'zackspack-',
  'zion-',
  'zoom-',
  'zoom3-',
  'zoomies-',
  'zraustin-',
  'zro-',
  'zrybor-',
];

export function getUrlPartnerCode() {
  const queryParameters = new URLSearchParams(typeof window === 'undefined' ? '' : window.location.search);
  // Support both 'pc' (partner code) and 'discount' query parameters
  const partnerCode = queryParameters.get('pc');
  return partnerCode?.trim() ? partnerCode : queryParameters.get('discount');
}

/**
 * Try to apply the code to the cart, and if it fails retry with the override prefix
 */
export async function applyPartnerCodeToCartWithPrefixRetry(cart: Cart, couponCode: string) {
  /**
   * When we distribute gift with purchase (GwP) partner's coupon codes, they are scoped to specific subscription plans.
   * Recurly does not allow editing the plan scope for existing coupons, so we've had to recreate all of the coupon
   * codes scoped to new subscription plans. They are recreated with `a-` added to the prefix. We want to detect
   * these and automatically return the corrected coupon code.
   *
   * For example: we had to recreate all of the (GwP) codes that were created for S3, after we began selling S3+.
   * The codes had to be recreated for S3+ subscription plans. A code like `bar-k-02paghj4ib` would be
   * recreated as `bar-k-a-02paghj4ib`
   */
  const matchingOverridePrefix = PREPAID_COUPON_PREFIXES_TO_REPLACE.map((p) => p.toLowerCase()).find(
    (prefix) => couponCode.toLowerCase().startsWith(prefix) && !couponCode.toLowerCase().startsWith(`${prefix}a-`),
  );
  if (!matchingOverridePrefix) {
    const result = await applyCouponToCart(cart, couponCode);
    return { result, codeToApply: couponCode };
  }

  // It's possible the code prefix is in the list but we don't want to automatically switch to the alternate version.
  // Consider this case: bark-fi-562zrq is a new code valid for current products. `bark-` is in the
  // PREPAID_COUPON_PREFIXES_TO_REPLACE, but bark-a-fi-562zrq is not a valid code. The reason why we test the alternate
  // first is a little tricky. The original version of a recreated code may still be valid, but it just doesn't apply
  // to the current products. So it's a valid code result, but we'd get a no-eligible-items error at checkout. However,
  // we often apply this code upon landing on the /redeem page when the cart is empty so ALL valid codes return a
  // no-eligible-items error at that time so we're unable to use that as critiera to decide we want to try
  // the alternate code.
  // Any code that was never recreated fails this probe with "Invalid coupon code" by design, so the probe doesn't
  // report to Sentry as a shopper error. The attempt below still reports a real one.
  const alternateCodeToTry = couponCode.replace(matchingOverridePrefix, `${matchingOverridePrefix}a-`);
  const alternateResult = await applyCouponToCart(cart, alternateCodeToTry, { reportFailure: false });
  if (isValidCodeResult(alternateResult)) {
    return { result: alternateResult, codeToApply: alternateCodeToTry };
  }

  // The alternate code wasn't a valid one, so just use the original.
  const result = await applyCouponToCart(cart, couponCode);
  return { result, codeToApply: couponCode };
}
